/**
 * Neuro Edge Technologies' official contact details, shown on every public
 * page (home, pricing, privacy policy). Change them here only.
 */
export const COMPANY_NAME = 'Neuro Edge Technologies LLP';
export const CONTACT_EMAIL = 'info@neuroedgetechnologies.com';
/** As shown to people. */
export const CONTACT_PHONE_DISPLAY = '+91 80550 06652';
/** For tel: and WhatsApp links (country code, digits only). */
export const CONTACT_PHONE_E164 = '+918055006652';

export const contactPhoneHref = `tel:${CONTACT_PHONE_E164}`;
export const contactWhatsAppHref = `https://wa.me/${CONTACT_PHONE_E164.slice(1)}`;
export const contactEmailHref = (subject?: string) =>
  `mailto:${CONTACT_EMAIL}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`;
